@import "../../utils/mixins/mixins.scss";

:host {
  button.pt-menu-root {
    border-radius: 0;
    width: 100%;
  }

  .pt-menu-root {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: 56px;
    cursor: pointer;
    border: none;
    text-decoration: none;
    position: relative;

    &::after {
      @include after-background-effect();
    }

    &.disabled {
      opacity: 0.5;

      &:hover {
        cursor: not-allowed;
      }
    }

    &.inactive {
      color: var(--color-foreground-de-emp);

      &:not(.disabled):hover,
      &:not(.disabled):focus {
        &::after {
          background-color: var(--color-icon-default);
          opacity: 0.12;
        }
        outline: none;
      }

      &:not(.disabled):active {
        &::after {
          background-color: var(--color-icon-default);
          opacity: 0.24;
        }
      }

      &:not(.disabled):focus {
        outline: none;
        outline-offset: -1px;
        outline-color: var(--color-foreground-highlight) !important;
      }
    }

    &.active {
      box-shadow: inset 4px 0px 0px var(--color-foreground-highlight);
      color: var(--color-foreground-highlight);

      &:not(.disabled):hover,
      &:not(.disabled):focus {
        &::after {
          background-color: var(--color-icon-default);
          opacity: 0.12;
        }
        outline: none;
      }

      &:not(.disabled):focus {
        outline: none;
        outline-offset: -1px;
        outline-color: var(--color-foreground-highlight) !important;
      }
    }
  }

  .pt-menu-waffle-item {
    display: flex;
    box-sizing: border-box;
    min-height: 40px;
    cursor: pointer;
    border: none;
    text-decoration: none;
    position: relative;
    padding-left: calc($pad-xxxl - $pad-xs);

    &.disabled {
      opacity: 0.5;

      &:hover {
        cursor: not-allowed;
      }
    }

    &.inactive {
      color: var(--color-foreground-de-emp);
      &:not(.disabled):hover,
      &:not(.disabled):focus {
        background-color: var(--color-hover);
        outline: none;
      }
    }
  }

  #nav-tile-more {
    box-shadow: none;
  }

  .pt-menu-face {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .pt-menu-waffle-face {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .pt-waffle-icon {
    padding-top: $pad-s;
  }

  .pt-menu-text {
    font-family: $font-normal;
    font-size: $font-left-rail-size;
    font-weight: $font-weight-semibold;
    line-height: $font-left-rail-line-height;
    text-align: center;
    margin: 0px 5px;
    max-width: 53px;
  }

  .pt-menu-waffle-text {
    font-family: $font-normal;
    padding-left: $pad-xxxl;
    font-size: $font-m-size;
    font-weight: $font-weight-semibold;
    color: var(--color-foreground);
    line-height: $font-m-line-height;
  }

  .pt-icon,
  .pt-icon-active {
    height: $icon-m;
    display: inline-block;
  }

  .pt-icon {
    svg {
      @include style-svg(var(--color-foreground-de-emp), var(--color-background), $icon-s);
    }
  }

  .pt-icon-active[data-test="nav-tile-svg-more"] {
    svg {
      @include style-svg(var(--color-foreground-highlight), var(--color-background), $icon-s);
    }
  }

  .pt-icon-active:not([data-test="nav-tile-svg-more"]) {
    svg {
      @include style-svg(var(--color-foreground-highlight), var(--color-background), $icon-s);
    }
  }

  .pt-list-badge {
    background-color: var(--color-foreground-highlight);
    border-radius: 50%;
    width: 6px;
    height: 6px;
    margin-left: 10px;
  }

  .pt-badge {
    background-color: var(--color-foreground-highlight);
    border-radius: 50%;
    width: 6px;
    height: 6px;
    top: 5px;
    right: 10px;
    position: absolute;
  }
}

:host(.redesign) {
  .pt-icon,
  .pt-icon-active {
    height: $icon-s;
  }

  .pt-waffle-icon {
    height: $icon-s;
    padding-left: 15px;
    padding-top: 0;
  }

  .pt-menu-waffle-text {
    padding-left: calc($pad-xxxl + $pad-m);
    @include poppins-list-item();
  }

  .pt-menu-root {
    min-height: 48px;
  }

  .pt-menu-root,
  .pt-menu-waffle-item {
    &.inactive {
      &:not(.disabled):focus {
        outline: auto;
        outline-color: var(--color-primary) !important;
        outline-offset: -1px;
      }
    }

    &.active {
      box-shadow: inset 4px 0px 0px var(--color-primary);
      color: var(--color-primary);

      &:not(.disabled):hover,
      &:not(.disabled):focus {
        &::after {
          background-color: unset;
        }
      }

      &:not(.disabled):focus {
        outline: auto;
        outline-color: var(--color-primary) !important;
        outline-offset: -1px;
      }

      .pt-menu-waffle-text {
        padding-left: calc($pad-xxxl + $pad-m);
        @include poppins-list-item(var(--color-primary));
      }
    }
  }

  .pt-menu-waffle-item {
    min-height: 48px;
    padding-left: 10px;
    box-sizing: border-box;

    &::after {
      @include after-background-effect();
    }

    &.inactive {
      &:not(.disabled):hover,
      &:not(.disabled):focus {
        background-color: unset;
        &::after {
          background-color: var(--color-icon-default);
          opacity: 0.12;
        }
      }

      &:not(.disabled):active {
        &::after {
          background-color: var(--color-icon-default);
          opacity: 0.24;
        }
      }
    }
  }

  .pt-icon-active[data-test="nav-tile-svg-more"] {
    svg {
      @include style-svg(var(--color-foreground-de-emp), var(--color-background), $icon-s);
    }
  }

  .pt-icon-active:not([data-test="nav-tile-svg-more"]) {
    svg {
      @include style-svg(var(--color-primary), var(--color-background), $icon-s);
    }
  }

  .pt-list-badge {
    background-color: var(--color-primary);
  }

  .pt-badge {
    background-color: var(--color-primary);
  }
}
